export const InsertSpaces = (value: string) => {
  value = value.replace(/([a-z])([A-Z])/g, "$1 $2");
  value = value.replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
  return value;
};
